export default __webpack_public_path__ + "static/media/Chairman.8185917a.jpg";